/**
 * accounts-public-api
 *
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams, HttpResponse, HttpEvent, HttpContext } from '@angular/common/http';
import { Observable } from 'rxjs';
import { OpenApiHttpParams, QueryParamStyle } from '../query.params';

// @ts-ignore
import { AppIdDto } from '../model/appId';
// @ts-ignore
import { ErrorResponseDto } from '../model/errorResponse';
// @ts-ignore
import { TermDocumentResponseDto } from '../model/termDocumentResponse';

// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS } from '../variables';
import { Configuration } from '../configuration';
import { BaseService } from '../api.base.service';
import { TermsPublicApiInterface } from './termsPublic.serviceInterface';

@Injectable({
    providedIn: 'root',
})
export class TermsPublicApi extends BaseService implements TermsPublicApiInterface {
    constructor(
        protected httpClient: HttpClient,
        @Optional() @Inject(BASE_PATH) basePath: string | string[],
        @Optional() configuration?: Configuration
    ) {
        super(basePath, configuration);
    }

    /**
     * Get active term documents
     * Returns the list of currently active term documents for the given application.
     * @endpoint get /terms
     * @param xAppId Application identifier
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     * @param options additional options
     */
    public getActiveTermDocuments(
        xAppId?: AppIdDto,
        observe?: 'body',
        reportProgress?: boolean,
        options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext; transferCache?: boolean }
    ): Observable<Array<TermDocumentResponseDto>>;
    public getActiveTermDocuments(
        xAppId?: AppIdDto,
        observe?: 'response',
        reportProgress?: boolean,
        options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext; transferCache?: boolean }
    ): Observable<HttpResponse<Array<TermDocumentResponseDto>>>;
    public getActiveTermDocuments(
        xAppId?: AppIdDto,
        observe?: 'events',
        reportProgress?: boolean,
        options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext; transferCache?: boolean }
    ): Observable<HttpEvent<Array<TermDocumentResponseDto>>>;
    public getActiveTermDocuments(
        xAppId?: AppIdDto,
        observe: any = 'body',
        reportProgress: boolean = false,
        options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext; transferCache?: boolean }
    ): Observable<any> {
        let localVarQueryParameters = new OpenApiHttpParams(this.encoder);

        let localVarHeaders = this.defaultHeaders;
        if (xAppId !== undefined && xAppId !== null) {
            localVarHeaders = localVarHeaders.set('x-app-id', String(xAppId));
        }

        // authentication (apiKeyHeader) required
        localVarHeaders = this.configuration.addCredentialToHeaders('apiKeyHeader', 'Ocp-Apim-Subscription-Key', localVarHeaders);

        // authentication (apiKeyQuery) required
        localVarQueryParameters = this.configuration.addCredentialToQuery(
            'apiKeyQuery',
            'subscription-key',
            localVarQueryParameters
        ) as OpenApiHttpParams;

        const localVarHttpHeaderAcceptSelected: string | undefined =
            options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept(['application/json']);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;

        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/terms`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<Array<TermDocumentResponseDto>>('get', `${basePath}${localVarPath}`, {
            context: localVarHttpContext,
            params: localVarQueryParameters.toHttpParams(),
            responseType: <any>responseType_,
            ...(withCredentials ? { withCredentials } : {}),
            headers: localVarHeaders,
            observe: observe,
            ...(localVarTransferCache !== undefined ? { transferCache: localVarTransferCache } : {}),
            reportProgress: reportProgress,
        });
    }
}
